module.exports = __webpack_public_path__ + "static/media/part1.3bddf8f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part1.jpg
// module id = 803
// module chunks = 1